import PropTypes from "prop-types";
import React, { useRef } from "react";
import { useUniqueId } from "../../common/hooks";
import { LiveRegion } from "../../private";
import STRINGS from "./strings";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

function FieldCounter(_ref) {
  let {
    characterCounter,
    charactersEntered,
    characterCounterCSS,
    id
  } = _ref;
  const {
    counterMax
  } = characterCounter;
  const characterCountAnnouncement = useRef("");
  const announcementKey = useUniqueId();
  let charactersCount = counterMax;
  const ANNOUNCEMENT_TIMEOUT = 1000;
  const CLEAR_ANNOUNCEMENT_TIMEOUT = 5000;
  charactersCount = counterMax - charactersEntered;
  characterCountAnnouncement.current = charactersEntered > counterMax ? `${charactersEntered - counterMax} ${STRINGS.charCountStatus3}` : `${charactersEntered} ${STRINGS.charCountStatus1} ${counterMax} ${STRINGS.charCountStatus2}`;
  return _jsxs("div", {
    css: characterCounterCSS,
    children: [_jsx(LiveRegion, {
      politeness: "polite",
      announcementDelay: ANNOUNCEMENT_TIMEOUT,
      clearAnnouncementDelay: CLEAR_ANNOUNCEMENT_TIMEOUT,
      children: characterCountAnnouncement.current
    }, announcementKey), _jsxs("div", {
      id: id,
      children: [charactersCount, " / ", counterMax]
    })]
  });
}

FieldCounter.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Displays the maximum character limit for the TextArea Field.
   * Decrements and displays the characters remaining as user enters the text into the Field
   */
  characterCounter: PropTypes.shape({
    /** Character counter text to display under the maximum counter limit. */
    counterUnderLimitText: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

    /** Character counter text to display over the maximum counter limit. */
    counterOverLimitText: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

    /** Maximum characters allowed */
    counterMax: PropTypes.number
  }).isRequired,
  charactersEntered: PropTypes.number.isRequired,
  characterCounterCSS: PropTypes.shape(),
  id: PropTypes.string
} : {};
FieldCounter.defaultProps = {
  characterCounterCSS: null,
  id: null
};
export default FieldCounter;